const mainSearchForm = {
  flights: "Flights",
  tours: "Tours",
  hotel: "Hotel",
  hotels: "Hotels",
  services: "Services",
  search: "SEARCH",
  destination: "Destination",
  includedServices: "Included Services",
  packageDuration: "Package Duration",
  checkInOut: "Check in / out",
  guests: "Guests",
  adults: "Adults",
  children: "Children",
  child: "Child",
  age: "Age",
  yearsOld: "Years old",
  rooms: "Rooms",
  close: "Close",
  searchType: "Search Type",
  accommodation: "Accommodation",
  transfers: "Transfers",
  toursExperiences: "Tours/Experiences",
  nights: "Nights",
  days: "Days",
  packageType: "Package Type",
  tourType: "Tour Type",
  packages: "Packages",
  cars: "Cars",
  cruises: "Cruises",
  infantsInSeat: "Infants in seat",
  infantsOnLap: "Infants on lap",
  airport: "Airport",
  passengers: "Passengers",
  departureReturn: "Departure and Return dates",
  origin: "Origin",
  roundTrip: "Round Trip",
  isRoundTrip: "Is Round Trip",
  dream_packages: "Dream Packages",
  partying: "Partying",
  thingsToDo: "Things To Do",
};

export default mainSearchForm;
